import clsx from "clsx";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";

import { useUserContext } from "@/features/user/contexts/useUserContext";

export function LanguageSwitchButton() {
  const { i18n, t } = useTranslation("common");
  const { push, asPath } = useRouter();
  const label = i18n.language === "en" ? t("lang.zhHk") : t("lang.en");
  const { user } = useUserContext();

  if (!!user) return null;

  async function handleChangeLanguage() {
    // firebase.analytics().logEvent(AnalyticsEventEnum.ProfileBasicSave);
    const locale = i18n.language === "en" ? "zh" : "en";
    push(asPath, asPath, { locale });
  }

  return (
    <button
      className={clsx(
        "inline-flex justify-center items-center py-2 text-xs font-medium text-primary hover:opacity-80 w-8",
      )}
      onClick={handleChangeLanguage}
    >
      <span>{label}</span>
    </button>
  );
}
